import { __read, __spread } from "tslib";
import { convertDate } from '@keen.io/time-utils';
import { KEEN_KEY, KEEN_VALUE } from '../../constants';
export var transformChronologicalNominal = function (_a, _b) {
    var result = _a.result;
    var dateModifier = _b.dateModifier;
    var data = [];
    var keys = new Set();
    keys.add(KEEN_VALUE);
    result.map(function (interval) {
        var _a;
        var _b = interval, start = _b.timeframe.start, value = _b.value;
        data.push((_a = {},
            _a[KEEN_KEY] = convertDate(start, dateModifier),
            _a[KEEN_VALUE] = value,
            _a));
    });
    return {
        data: data,
        keys: __spread(keys),
    };
};
